import PoWorkbenchPrioritySelect from 'volta/components/po-workbench/priority-select';
import orElse from 'volta/helpers/or-else';

import type { TOC } from '@ember/component/template-only';
import type { TButtonSize } from 'volta/components/bv-btn';

export interface IPriorityFilterDefinitionArgs {}

interface PriorityFilterSArgs {
  yesLabel?: string;
  noLabel?: string;
  size?: TButtonSize;
  fullWidth?: boolean;
  renderInPlace?: boolean;
}

interface IFiltersPriorityFilterSignature {
  Args: FilterComponentSignature<PriorityFilterSArgs>['Args'] & PriorityFilterSArgs;
  Element: HTMLElement;
}

const FiltersPriorityFilterComponent: TOC<IFiltersPriorityFilterSignature> = <template>
  <PoWorkbenchPrioritySelect
    @multiple={{@multiple}}
    @allowClear={{true}}
    @fill={{true}}
    @matchTriggerWidth={{true}}
    {{! @glint-ignore }}
    @values={{@values}}
    {{! @glint-ignore }}
    @onChangeMany={{@onChange}}
    {{! @glint-ignore }}
    @onChange={{@onChange}}
    @renderInPlace={{orElse @componentArgs.renderInPlace @renderInPlace}}
    @dataName={{@name}}
    ...attributes
  />
</template>;

export default FiltersPriorityFilterComponent;

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'Filters::PriorityFilter': typeof FiltersPriorityFilterComponent;
    'filters/priority-filter': typeof FiltersPriorityFilterComponent;
  }
}
